// extracted by mini-css-extract-plugin
export default {"section":"jB-z","inSectionButton":"kB-z","addressCard":"lB-z","disabled":"mB-z","cautionBox":"nB-z","failureBox":"oB-z","fade-out":"pB-z","successBox":"qB-z"};